import { BaseModel } from './BaseModel';

export class ModpackBuild extends BaseModel {
    static Queued = 'queued';
    static Running = 'running';
    static OnDemand = 'on_demand';
    static Failed = 'failed';
    static Succeeded = 'succeeded';

    public versionId = '';
    public name = '';
    public releaseType = -1;
    public modLoader = '';
    public modLoaderVersion = '';
    public minecraftVersion = '';
    public serverPack = false;
    public downloads = -1;
    public uploadedAt = '';
    public status = '';
    public validatedAt: string | null = null;
    public startedAt: string | null = null;
    public error: string | null = null;
    public hasLogs = false;

    public isClientPack(): boolean {
        return !this.serverPack;
    }

    public isPending(): boolean {
        return this.status === ModpackBuild.Queued || this.status === ModpackBuild.Running;
    }
}
